import { testId } from '../../utils';
import { TypographyVariant } from './Typography';
import clsx from 'clsx';
import React from 'react';

export type LinkButtonVariant = 'default' | 'no-underline';

export interface LinkButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: LinkButtonVariant;
  disabled?: boolean;
  asChild?: boolean;
  'data-testid': string;
}

export const LinkButton = React.forwardRef<HTMLButtonElement, LinkButtonProps>(
  (
    {
      className,
      variant = 'default',
      disabled = false,
      'data-testid': dataTestId,
      ...props
    },
    ref,
  ) => {
    return (
      <button
        {...testId(dataTestId)}
        className={clsx(
          'text-blue-active  bg-transparent border-none hover:text-blue-dark',
          'px-0 h-auto text-left w-auto rounded-none',
          'relative disabled:pointer-events-none disabled:opacity-50',
          className,
          variant === 'default' && 'underline',
          variant === 'no-underline' && 'no-underline',
        )}
        ref={ref}
        disabled={disabled}
        {...props}
      >
        {props.children}
      </button>
    );
  },
);
LinkButton.displayName = 'LinkButton';
